export default "__VITE_ASSET__BtovPb7$__"